import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { isEmailValid, removeEmojis } from '../../../../services/utils';

const useConfirmRegisteredEmailForm = ({
  onConfirm = () => { },
  registeredEmail = '',
}) => {
  const { t } = useTranslation('petDemos');

  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');

  const getError = (value) => {
    if (!isEmailValid(value)) {
      return t('certificateLinking.confirmRegisteredEmail.invalidEmail');
    }

    if (value.trim().toLowerCase() !== registeredEmail.trim().toLowerCase()) {
      return t('certificateLinking.confirmRegisteredEmail.emailMismatch');
    }

    return '';
  };

  const handleEmailChange = (event) => {
    setEmail(removeEmojis(event.target.value));
    setEmailError('');
  };

  const handleEmailBlur = () => {
    setEmailError(getError(email));
  };

  const handleSubmit = () => {
    const error = getError(email);

    if (error) {
      setEmailError(error);
      return;
    }

    onConfirm();
  };

  return {
    email,
    emailError,
    handleEmailBlur,
    handleEmailChange,
    handleSubmit,
  };
};

export { useConfirmRegisteredEmailForm };
